import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Modal from '../../../Components/UI/Modal/Modal';
import Button from '../../../Components/UI/Forms/Button/Button';
import Message from '../../../Components/UI/Messages/Message';
import * as actions from '../../../Store/Actions';

const DeleteDemand = ({ show, close, demand, deleteDemand, error, loading }) => {
  const confirmDelete = async () => {
    const deleted = await deleteDemand(demand.demand_id);
    if (deleted) close();
  };

  return (
    <Modal opened={show} close={close}>
      <Content>
        <h2>Supprimer cette demande ?</h2>
        <p>
          Cette action est irréversible. Les propositions et échanges associés à cette demande
          seront également perdus.
        </p>
        <DemandPreview>{demand.description || demand.demand || 'Demande sans description'}</DemandPreview>
        <Actions>
          <Button contain type="button" onClick={close} disabled={loading}>Annuler</Button>
          <Button
            contain
            color="red"
            type="button"
            onClick={confirmDelete}
            disabled={loading}
            loading={loading ? 'Suppression…' : null}
          >
            Supprimer définitivement
          </Button>
        </Actions>
        <Message error show={Boolean(error)}>{error}</Message>
      </Content>
    </Modal>
  );
};

const Content = styled.div`
  padding: 0.5rem;
  color: var(--color-text);

  h2 { margin: 0 0 0.65rem; color: var(--color-mainDark); }
  p { margin: 0; color: var(--color-textMuted); line-height: 1.6; }
`;

const DemandPreview = styled.blockquote`
  margin: 1.25rem 0;
  padding: 0.9rem 1rem;
  border-left: 3px solid var(--color-errorRed);
  border-radius: 0 0.7rem 0.7rem 0;
  background: #fff5f5;
  color: #5c3030;
  line-height: 1.55;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.75rem;
`;

const mapStateToProps = ({ demands }) => ({
  error: demands.deleteDemand.error,
  loading: demands.deleteDemand.loading,
});

export default connect(mapStateToProps, { deleteDemand: actions.deleteDemand })(DeleteDemand);
